"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _LinkCustomParams = _interopRequireDefault(require("MeetingsBase/models/LinkCustomParams"));

var _strings = require("MeetingsBase/constants/strings");

var defaults = {
  customParams: new _LinkCustomParams.default(),
  slug: null,
  isDefaultLink: false,
  id: _strings.NEW_LINK_ID,
  name: null,
  link: null,
  type: null,
  meetingsUserIds: (0, _immutable.List)(),
  meetingsUserId: null,
  formGuid: null
};

var MeetingsLink =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(MeetingsLink, _Record);

  function MeetingsLink() {
    (0, _classCallCheck2.default)(this, MeetingsLink);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MeetingsLink).apply(this, arguments));
  }

  (0, _createClass2.default)(MeetingsLink, [{
    key: "convertToJSON",
    value: function convertToJSON() {
      return this.update('customParams', function (customParams) {
        return customParams.convertToJSON();
      }).toJS();
    }
  }], [{
    key: "from",
    value: function from(json) {
      return new MeetingsLink((0, _extends2.default)({}, json)).set('customParams', _LinkCustomParams.default.from(json.customParams)).set('meetingsUserIds', (0, _immutable.fromJS)(json.meetingsUserIds)).set('name', json.name);
    }
  }, {
    key: "fromId",
    value: function fromId(json) {
      return new MeetingsLink(json).set('customParams', _LinkCustomParams.default.from(json.customParams)).set('meetingsUserIds', (0, _immutable.fromJS)(json.meetingsUserIds)).set('name', json.name);
    }
  }]);
  return MeetingsLink;
}((0, _immutable.Record)(defaults));

exports.default = MeetingsLink;
module.exports = exports.default;